
export const CUSTOMER_TABS = [
  { key: "all", label: "All Customers" },
  { key: "active", label: "Active" },
  { key: "inactive", label: "Inactive" },
  { key: "blocked", label: "Banned" },
];

export const CUSTOMER_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "waitingReply", label: "Waiting Reply" },
  { value: "inactive", label: "Inactive" },
  { value: "blocked", label: "Banned" },
];

export const CUSTOMER_EDIT_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const CUSTOMERS_DUMMY = [
  {
    id: "c1",
    name: "Robert Fox",
    email: "jessica.hanson@example.com",
    phone: "(704) 555-0127",
    group: "Group A",
    team: "Sales Team",
    status: "active",
    chats: 60,
    lastActivity: "1 month ago",
    avatar: null,
  },
  {
    id: "c2",
    name: "Devon Lane",
    email: "tanya.hill@example.com",
    phone: "(229) 555-0109",
    group: "Group B",
    team: "Support Team",
    status: "waitingReply",
    chats: 35,
    lastActivity: "2 week ago",
    avatar: null,
  },
  {
    id: "c3",
    name: "Courtney Henry",
    email: "nevaeh.simmons@example.com",
    phone: "(239) 555-0108",
    group: "Group A",
    team: "Sales Team",
    status: "active",
    chats: 19,
    lastActivity: "15 minutes ago",
    avatar: null,
  },
  {
    id: "c4",
    name: "Leslie Alexander",
    email: "michelle.rivera@example.com",
    phone: "(316) 555-0116",
    group: "Group B",
    team: "Sales Team",
    status: "inactive",
    chats: 64,
    lastActivity: "5 months ago",
    avatar: null,
  },
  {
    id: "c5",
    name: "Theresa Webb",
    email: "curtis.weaver@example.com",
    phone: "(603) 555-0123",
    group: "Group A",
    team: "Support Team",
    status: "active",
    chats: 27,
    lastActivity: "2 months ago",
    avatar: null,
  },
  {
    id: "c6",
    name: "Savannah Nguyen",
    email: "kenzi.lawson@example.com",
    phone: "(270) 555-0117",
    group: "Group B",
    team: "Sales Team",
    status: "inactive",
    chats: 53,
    lastActivity: "1 month ago",
    avatar: null,
  },
  {
    id: "c7",
    name: "Wade Warren",
    email: "sara.cruz@example.com",
    phone: "(208) 555-0112",
    group: "Group B",
    team: "Support Team",
    status: "waitingReply",
    chats: 42,
    lastActivity: "1 month ago",
    avatar: null,
  },
  {
    id: "c8",
    name: "Esther Howard",
    email: "alma.lawson@example.com",
    phone: "(671) 555-0110",
    group: "Group A",
    team: "Sales Team",
    status: "active",
    chats: 74,
    lastActivity: "15 minutes ago",
    avatar: null,
  },
  {
    id: "c9",
    name: "Albert Flores",
    email: "michael.mitc@example.com",
    phone: "(303) 555-0105",
    group: "Group B",
    team: "Sales Team",
    status: "active",
    chats: 15,
    lastActivity: "5 hours ago",
    avatar: null,
  },
  {
    id: "c10",
    name: "Jerome Bell",
    email: "dolores.chambers@example.com",
    phone: "(504) 555-0174",
    group: "Group A",
    team: "Sales Team",
    status: "blocked",
    chats: 8,
    lastActivity: "3 months ago",
    avatar: null,
  },
];

// ============ TEAMS ============
export const TEAM_TABS = [
  { key: "all", label: "All Teams" },
  { key: "active", label: "Active" },
  { key: "archived", label: "Archived" },
];

export const TEAM_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
];

const TEAM_DESC =
  "First-line support team handling initial customer inquiries";

export const TEAMS_DUMMY = [
  {
    id: "t1",
    name: "L1 Support",
    description: TEAM_DESC,
    group: "Group A",
    agents: 64,
    totalChats: 60,
    totalTickets: 60,
    status: "active",
    created: "22 Oct, 2020",
    sidebarChats: 1890,
    sidebarTickets: 12,
    detailAgents: 5,
    detailChats: 890,
    detailTickets: 423,
  },
  { id: "t2", name: "L2 Support", description: TEAM_DESC, group: "Group B", agents: 35, totalChats: 35, totalTickets: 35, status: "active", created: "22 Oct, 2020" },
  { id: "t3", name: "L3 Support", description: TEAM_DESC, group: "Group A", agents: 19, totalChats: 19, totalTickets: 19, status: "active", created: "22 Oct, 2020" },
  { id: "t4", name: "L4 Support", description: TEAM_DESC, group: "Group B", agents: 64, totalChats: 64, totalTickets: 64, status: "active", created: "22 Oct, 2020" },
  { id: "t5", name: "Sales Team", description: TEAM_DESC, group: "Group A", agents: 27, totalChats: 27, totalTickets: 27, status: "active", created: "22 Oct, 2020" },
  { id: "t6", name: "IT Support", description: TEAM_DESC, group: "Group B", agents: 53, totalChats: 53, totalTickets: 53, status: "active", created: "22 Oct, 2020" },
  { id: "t7", name: "Billing Team", description: TEAM_DESC, group: "Group A", agents: 42, totalChats: 42, totalTickets: 42, status: "active", created: "22 Oct, 2020" },
  { id: "t8", name: "Onboarding Team", description: TEAM_DESC, group: "Group A", agents: 74, totalChats: 74, totalTickets: 74, status: "active", created: "22 Oct, 2020" },
  { id: "t9", name: "Enterprise Team", description: TEAM_DESC, group: "Group B", agents: 15, totalChats: 15, totalTickets: 15, status: "active", created: "22 Oct, 2020" },
  { id: "t10", name: "Legacy Team", description: TEAM_DESC, group: "Group A", agents: 22, totalChats: 22, totalTickets: 22, status: "archived", created: "22 Oct, 2020" },
];

// ============ GROUPS ============
export const GROUP_TABS = [
  { key: "all", label: "All Groups" },
  { key: "active", label: "Active" },
  { key: "archived", label: "Archived" },
];

export const GROUP_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
];

const GROUP_TEAM_DESC =
  "First-line support team handling initial customer inquiries and basic troubleshooting.";

const STANDARD_SUPPORT_TEAMS = [
  {
    id: "gst1",
    name: "L1 Support",
    description: GROUP_TEAM_DESC,
    status: "active",
    agents: 8,
    chats: 1240,
  },
  {
    id: "gst2",
    name: "L2 Support",
    description: GROUP_TEAM_DESC,
    status: "active",
    agents: 6,
    chats: 980,
  },
];

export const GROUPS_DUMMY = [
  {
    id: "g1",
    name: "Standard Support",
    totalTeams: 5,
    totalAgents: 21,
    totalChats: 3200,
    totalTickets: 1423,
    status: "active",
    createdDate: "1 month ago",
    createdDisplay: "18/05/2026",
    teams: STANDARD_SUPPORT_TEAMS,
  },
  {
    id: "g2",
    name: "Premium Support",
    totalTeams: 3,
    totalAgents: 14,
    totalChats: 2250,
    totalTickets: 1120,
    status: "active",
    createdDate: "2 weeks ago",
    createdDisplay: "05/05/2026",
    teams: [
      {
        id: "gpt1",
        name: "Premium Desk",
        description: GROUP_TEAM_DESC,
        status: "active",
        agents: 5,
        chats: 890,
      },
    ],
  },
  {
    id: "g3",
    name: "Enterprise",
    totalTeams: 4,
    totalAgents: 18,
    totalChats: 4100,
    totalTickets: 1980,
    status: "active",
    createdDate: "15 minutes ago",
    createdDisplay: "19/05/2026",
    teams: [
      {
        id: "get1",
        name: "Enterprise Care",
        description: GROUP_TEAM_DESC,
        status: "active",
        agents: 9,
        chats: 2100,
      },
    ],
  },
  {
    id: "g4",
    name: "Starter",
    totalTeams: 2,
    totalAgents: 6,
    totalChats: 540,
    totalTickets: 210,
    status: "archived",
    createdDate: "5 months ago",
    createdDisplay: "12/12/2025",
    teams: [],
  },
  {
    id: "g5",
    name: "Onboarding",
    totalTeams: 2,
    totalAgents: 9,
    totalChats: 780,
    totalTickets: 340,
    status: "active",
    createdDate: "2 months ago",
    createdDisplay: "20/03/2026",
    teams: [],
  },
  {
    id: "g6",
    name: "Billing Support",
    totalTeams: 3,
    totalAgents: 11,
    totalChats: 1650,
    totalTickets: 890,
    status: "active",
    createdDate: "1 month ago",
    createdDisplay: "18/04/2026",
    teams: [],
  },
  {
    id: "g7",
    name: "Technical Support",
    totalTeams: 4,
    totalAgents: 16,
    totalChats: 2900,
    totalTickets: 1540,
    status: "archived",
    createdDate: "1 month ago",
    createdDisplay: "10/04/2026",
    teams: [],
  },
  {
    id: "g8",
    name: "Sales Support",
    totalTeams: 2,
    totalAgents: 7,
    totalChats: 920,
    totalTickets: 410,
    status: "active",
    createdDate: "15 minutes ago",
    createdDisplay: "19/05/2026",
    teams: [],
  },
  {
    id: "g9",
    name: "Partner Support",
    totalTeams: 3,
    totalAgents: 10,
    totalChats: 1340,
    totalTickets: 620,
    status: "active",
    createdDate: "5 hours ago",
    createdDisplay: "19/05/2026",
    teams: [],
  },
  {
    id: "g10",
    name: "Legacy Support",
    totalTeams: 1,
    totalAgents: 4,
    totalChats: 320,
    totalTickets: 95,
    status: "active",
    createdDate: "8 hours ago",
    createdDisplay: "19/05/2026",
    teams: [],
  },
];

// ============ AGENTS ============
export const AGENT_TABS = [
  { key: "all", label: "All Agents" },
  { key: "online", label: "Online" },
  { key: "offline", label: "Offline" },
  { key: "suspended", label: "Suspended" },
];

export const AGENT_ROLE_FILTER_OPTIONS = [
  { value: "agent", label: "Agent" },
  { value: "admin", label: "Admin" },
  { value: "admin_with_billing", label: "Super Admin" },
];

export const AGENT_STATUS_OPTIONS = [
  { value: "accepting", label: "Accepting", dot: "#52C41A" },
  { value: "notAccepting", label: "Not Accepting", dot: "#FF4D4F" },
  { value: "offline", label: "Offline", dot: "#93A1B0" },
  { value: "invitationSent", label: "Invitation sent", dot: "#93A1B0" },
  { value: "suspended", label: "Suspended", dot: "#FAAD14" },
];

export const AGENT_CHAT_LIMIT_OPTIONS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map(
  (value) => ({ value, label: value })
);

export const AGENT_TIMEZONE_OPTIONS = [
  { value: "America/Los_Angeles", label: "America/Los_Angeles" },
  { value: "America/Denver", label: "America/Denver" },
  { value: "America/Chicago", label: "America/Chicago" },
  { value: "America/New_York", label: "America/New_York" },
  { value: "Europe/London", label: "Europe/London" },
  { value: "Europe/Paris", label: "Europe/Paris" },
  { value: "Asia/Dubai", label: "Asia/Dubai" },
  { value: "Asia/Kolkata", label: "Asia/Kolkata" },
  { value: "Asia/Singapore", label: "Asia/Singapore" },
  { value: "Australia/Sydney", label: "Australia/Sydney" },
];

export const AGENT_KB_ROLE_OPTIONS = [
  { value: "contributor", label: "Contributor" },
  { value: "editor", label: "Editor" },
  { value: "viewer", label: "Viewer" },
];

/** @deprecated Use AGENT_KB_ROLE_OPTIONS for agent edit */
export const AGENT_KB_PERMISSION_OPTIONS = AGENT_KB_ROLE_OPTIONS;

export const AGENT_ROLE_OPTIONS = [
  { value: "teamLead", label: "Team Lead" },
  { value: "agent", label: "Agent" },
  { value: "admin", label: "Admin" },
];

export const AGENTS_DUMMY = [
  { id: "a1", name: "Robert Fox", email: "jessica.hanson@example.com", role: "Team Lead", chats: 60, group: "Group A", status: "active", lastActivity: "1 month ago", avatar: null },
  { id: "a2", name: "Devon Lane", email: "tanya.hill@example.com", role: "Agent", chats: 35, group: "Group B", status: "inactive", lastActivity: "2 week ago", avatar: null },
  { id: "a3", name: "Courtney Henry", email: "nevaeh.simmons@example.com", role: "Team Lead", chats: 19, group: "Group A", status: "offline", lastActivity: "15 minutes ago", avatar: null },
  { id: "a4", name: "Leslie Alexander", email: "michelle.rivera@example.com", role: "Agent", chats: 64, group: "Group B", status: "active", lastActivity: "5 months ago", avatar: null },
  { id: "a5", name: "Theresa Webb", email: "curtis.weaver@example.com", role: "Agent", chats: 27, group: "Group A", status: "inactive", lastActivity: "2 months ago", avatar: null },
  { id: "a6", name: "Savannah Nguyen", email: "kenzi.lawson@example.com", role: "Agent", chats: 53, group: "Group B", status: "active", lastActivity: "1 month ago", avatar: null },
  { id: "a7", name: "Wade Warren", email: "sara.cruz@example.com", role: "Team Lead", chats: 42, group: "Group B", status: "active", lastActivity: "1 month ago", avatar: null },
  { id: "a8", name: "Esther Howard", email: "alma.lawson@example.com", role: "Agent", chats: 74, group: "Group A", status: "offline", lastActivity: "15 minutes ago", avatar: null },
  { id: "a9", name: "Albert Flores", email: "michael.mitc@example.com", role: "Agent", chats: 15, group: "Group B", status: "offline", lastActivity: "5 hours ago", avatar: null },
  { id: "a10", name: "Jenny Wilson", email: "deanna.curtis@example.com", role: "Admin", chats: 44, group: "Group A", status: "suspended", lastActivity: "3 weeks ago", avatar: null },
];

export const PEOPLE_GROUP_OPTIONS = [
  { value: "Group A", label: "Group A" },
  { value: "Group B", label: "Group B" },
];

export const PEOPLE_TEAM_OPTIONS = [
  { value: "Sales Team", label: "Sales Team" },
  { value: "Support Team", label: "Support Team" },
];
